// import React from 'react';
import { useLayoutEffect, useState } from 'react';

function ScreenSize() {
    const [screenSize, setScreenSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setScreenSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return screenSize;
}

export {ScreenSize};